<nav class="flex items-center justify-between bg-gradient-to-t from-headerfr to-headerto p-2">
    <div class="flex items-end ml-6">
        <div class="mt-1 bg-yellow-200 overflow-hidden p-2" style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;">
            <a [routerLink]="['']">
                <img class="h-8 w-full hover:opacity-75" src="../assets/img/logo_fusilli_FINAL_web.svg">
            </a>
        </div>
        <div class="text-2xl text-yellow-200 ml-6 cursor-default whitespace-nowrap">
            Knowledge Community Platform
        </div>
    </div>
    <div class="mt-4 flex justify-end items-end">
        <a [routerLink]="['']" routerLinkActive="active" (click)="onHome()"
            class="text-xl px-4 text-yellow-200 hover:underline">Home</a>
        <a routerLink="/Transformation-Journeys" routerLinkActive="active"
            class="text-xl px-4 text-yellow-200 hover:underline">Transformation Journeys</a>
        <div class="relative">
            <button type="button" class="text-xl px-4 text-yellow-200 hover:underline" (mouseenter)="openMenu()"
                (mouseleave)="startCloseMenuTimer()">
                FUSILLI Results <i class="fas fa-chevron-down text-sm"></i>
            </button>
            <div id="results-menu" [ngClass]="{'hidden': !menuOpen}" (mouseenter)="cancelCloseMenuTimer()"
                (mouseleave)="startCloseMenuTimer()"
                class="z-50 absolute mt-2 bg-gradient-to-t from-headerfr to-headerto w-44 rounded">
                <button type="button" class="mt-2 text-yellow-200 text-xl px-4 inline-block hover:underline"
                    (click)="onEvaluation()">
                    City Results
                </button>
                <button type="button" class="text-yellow-200 text-xl px-4 inline-block hover:underline"
                    (click)="onResults()">
                    Project Results
                </button>
                <button type="button" class="text-yellow-200 text-xl px-4 inline-block hover:underline"
                    (click)="onMethodology()">
                    Methodology
                </button>
            </div>
        </div>
        <a routerLink="/Showcases" routerLinkActive="active" class="text-xl px-4 text-yellow-200 hover:underline">
            Showcases</a>
        <button *ngIf="showLogin" class="text-xl px-4 text-yellow-200 hover:underline" (click)="login()">FUSILLI
            partners login
        </button>
        <button *ngIf="!showLogin" class="text-xl px-4 text-yellow-200 hover:underline"
            (click)="logout()">Logout</button>

    </div>
</nav>